import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 80px;
  width: 100%;
`;

export const BoxImage = styled.div`
  display: inline-block;
  height: 45px;

  & > img {
    height: 100%;
  }
`;
